import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const SchoolSection = ({ number, formData, handleChange, prefix }) => (
  <div className="bg-gray-50 p-6 rounded-lg space-y-4">
    <h4 className="font-bold text-lg">School #{number} {number > 1 && '(if applicable)'}</h4>
    
    <div>
      <Label htmlFor={`${prefix}_name`}>Name of School, College, or University {number === 1 && '*'}</Label>
      <Input
        id={`${prefix}_name`}
        value={formData[`${prefix}_name`]}
        onChange={(e) => handleChange(`${prefix}_name`, e.target.value)}
        required={number === 1}
      />
    </div>

    <div>
      <Label htmlFor={`${prefix}_address`}>School Address {number === 1 && '*'}</Label>
      <Input
        id={`${prefix}_address`}
        value={formData[`${prefix}_address`]}
        onChange={(e) => handleChange(`${prefix}_address`, e.target.value)}
        required={number === 1}
      />
    </div>

    <div className="grid md:grid-cols-3 gap-4">
      <div>
        <Label htmlFor={`${prefix}_city`}>City {number === 1 && '*'}</Label>
        <Input
          id={`${prefix}_city`}
          value={formData[`${prefix}_city`]}
          onChange={(e) => handleChange(`${prefix}_city`, e.target.value)}
          required={number === 1}
        />
      </div>
      <div>
        <Label htmlFor={`${prefix}_state`}>State {number === 1 && '*'}</Label>
        <Input
          id={`${prefix}_state`}
          value={formData[`${prefix}_state`]}
          onChange={(e) => handleChange(`${prefix}_state`, e.target.value)}
          placeholder="PA"
          required={number === 1}
        />
      </div>
      <div>
        <Label htmlFor={`${prefix}_zip`}>ZIP Code {number === 1 && '*'}</Label>
        <Input
          id={`${prefix}_zip`}
          value={formData[`${prefix}_zip`]}
          onChange={(e) => handleChange(`${prefix}_zip`, e.target.value)}
          required={number === 1}
        />
      </div>
    </div>

    <div className="grid md:grid-cols-2 gap-4">
      <div>
        <Label htmlFor={`${prefix}_degree`}>Degree or Certification Earned {number === 1 && '*'}</Label>
        <Input
          id={`${prefix}_degree`}
          value={formData[`${prefix}_degree`]}
          onChange={(e) => handleChange(`${prefix}_degree`, e.target.value)}
          required={number === 1}
        />
      </div>
      <div>
        <Label htmlFor={`${prefix}_major`}>Field of Study / Major {number === 1 && '*'}</Label>
        <Input
          id={`${prefix}_major`}
          value={formData[`${prefix}_major`]}
          onChange={(e) => handleChange(`${prefix}_major`, e.target.value)}
          required={number === 1}
        />
      </div>
    </div>

    <div className="grid md:grid-cols-2 gap-4">
      <div>
        <Label htmlFor={`${prefix}_dates`}>Dates Attended (From – To) {number === 1 && '*'}</Label>
        <Input
          id={`${prefix}_dates`}
          value={formData[`${prefix}_dates`]}
          onChange={(e) => handleChange(`${prefix}_dates`, e.target.value)}
          placeholder="MM/YYYY - MM/YYYY"
          required={number === 1}
        />
      </div>
      <div>
        <Label htmlFor={`${prefix}_year_completed`}>Year Completed</Label>
        <Input
          id={`${prefix}_year_completed`}
          value={formData[`${prefix}_year_completed`]}
          onChange={(e) => handleChange(`${prefix}_year_completed`, e.target.value)}
          placeholder="YYYY"
        />
      </div>
    </div>

    <div>
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={formData[`${prefix}_currently_enrolled`] === 'yes'}
          onChange={(e) => handleChange(`${prefix}_currently_enrolled`, e.target.checked ? 'yes' : 'no')}
        />
        Currently Enrolled
      </label>
    </div>
  </div>
);

const Step6Education = ({ formData, handleChange }) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2">Education Information</h3>
        <p className="text-gray-600">Please provide your educational background</p>
      </div>

      <div>
        <Label htmlFor="education_level">Highest Level of Education Completed *</Label>
        <select
          id="education_level"
          value={formData.education_level}
          onChange={(e) => handleChange('education_level', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
          required
        >
          <option value="">Select...</option>
          <option value="high_school">High School / GED</option>
          <option value="some_college">Some College</option>
          <option value="associate">Associate Degree</option>
          <option value="bachelor">Bachelor's Degree</option>
          <option value="master">Master's Degree</option>
          <option value="doctorate">Doctorate</option>
          <option value="other">Other</option>
        </select>
      </div>

      <SchoolSection number={1} formData={formData} handleChange={handleChange} prefix="school1" />
      <SchoolSection number={2} formData={formData} handleChange={handleChange} prefix="school2" />
      <SchoolSection number={3} formData={formData} handleChange={handleChange} prefix="school3" />

      <div className="bg-amber-50 p-6 rounded-lg">
        <Label>Do you have prior work experience in Human Services or in a Direct Support role (DSP/DSA)? *</Label>
        <div className="flex gap-4 mt-2">
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="has_human_services_experience"
              value="yes"
              checked={formData.has_human_services_experience === 'yes'}
              onChange={(e) => handleChange('has_human_services_experience', e.target.value)}
              required
            />
            Yes
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="has_human_services_experience"
              value="no"
              checked={formData.has_human_services_experience === 'no'}
              onChange={(e) => handleChange('has_human_services_experience', e.target.value)}
            />
            No
          </label>
        </div>
      </div>
    </div>
  );
};

export default Step6Education;